export const map_message = {
   sessionVhndCoverageMessage: "Coverage area address is not within district range",
   sessionAddCoverageMessage: "Coverage area address already exists",
   facilityGeometryMessage: "lattitude, longitude and address is not within district range.",
   sessionGeometryMessage: "Address is not within district range.",
   errorMessageSessionSite: "Unable to contact the Map Services provided by NIC. You can proceed with the session site create or update without coverage area and filling the address data manually.",
   errorMessageFacilityUpdate: "Unable to contact the Map Services provided by NIC. You can proceed with the facility update filling the location data manually.",
   errorMessageFacilityCreate: "Unable to contact the Map Services provided by NIC. You can proceed with the facility creation filling the location data manually.",
   errorMessageFacilityCreateAbdm: "Unable to contact the Map Services provided by NIC. You can proceed with the facility creation using the location data received from ABDM.",
   bharatMapErrorMessage: 'Unable to contact the Map Services provided by NIC.',
   bharatMapDisableMessage: 'Due to some technical issues the map functionality is disabled temporarily.',
   mapConfigDisabled: 'Due to some technical issues the map functionality is disabled temporarily. You can proceed with filling or selecting data manually.'
};


export const page_type ={
    session_site_vhnd: 'session_site_vhnd',
    health_facility: 'health_facility',
    approval_view: 'approval_view'
};